<div class="g-container">
  <div class="posts">
    <h2 class="posts-header">
      @switch (category()) {
        @case ('lastPosts') {
          {{ 'global.last_posts' | translate }}
        }
        @case ('lastWorks') {
          {{ 'posts_preview.examples' | translate }}
        }
      }
    </h2>

    <div class="posts-items">
      @for (post of posts() | slice:0:3; track post.slug) {
        <div class="posts-item post">
          <div class="post-container">
            <a
              class="post-img-container g-main-link"
              [routerLink]="['/', 'blog', post.slug]"
              routerLinkWithLang
              [title]="post.name"
            >
              <img
                class="post-img"
                [src]="post.featuredMedia.variantsUrls.original"
                [alt]="post.name"
                loading="lazy"
              >
            </a>

            <div class="post-info">
              <div class="post-category">
                <a
                  class="post-ref g-main-link"
                  [routerLink]="['/', 'blog', post.category.slug]"
                  routerLinkWithLang
                  [title]="post.category.name"
                >
                  {{ post.category.name }}
                </a>
              </div>
              <h3 class="post-title">
                <a class="g-main-link g-main-link-black" [routerLink]="['/', 'blog', post.slug]" routerLinkWithLang [title]="post.name">{{ post.name }}</a>
              </h3>
              <div class="post-date">
                {{ 'global.added' | translate }}: {{ post.publishedAt | date: 'd MMMM, y' : undefined : languageService.getCurrentLocale() }}
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>

